var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH678(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffdf97;}.cls-2{fill:#ea8b49;}.cls-3,.cls-4{fill:#fff;}.cls-5{fill:#ffbf57;}.cls-6{fill:#efecea;}.cls-7{fill:#d37a3d;}.cls-8{fill:#6dd3ce;}.cls-4{opacity:0;}.cls-9{fill:none;stroke:#ffd15c;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.5,96.61h-6.01v-18.32c0-2.09-1.69-3.78-3.78-3.78h-6.42v-.49c0-2.04-1.66-3.7-3.7-3.7h-23.93c-2.04,0-3.7,1.66-3.7,3.7v.49h-13.66v-.49c0-2.04-1.66-3.7-3.7-3.7h-45.42c-2.04,0-3.7,1.66-3.7,3.7v14.77c0,1.66,1.1,3.05,2.6,3.52v4.31h-3.1c-2.29,0-4.15,1.86-4.15,4.15v13.87c0,2.29,1.86,4.15,4.15,4.15h3.1v16.68c0,2.09,1.69,3.78,3.78,3.78h21.11v1.71c0,2.04,1.66,3.7,3.7,3.7h50.79c2.04,0,3.7-1.66,3.7-3.7v-1.71h18.54c2.09,0,3.78-1.69,3.78-3.78v-16.68h6.01c2.04,0,3.7-1.66,3.7-3.7v-14.77c0-2.04-1.66-3.7-3.7-3.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.98,158.95c-42.02-20.35-49.28-79.34-13.38-109.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M82.63,163.28c-.68-.21-1.35-.43-2.02-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.87,39.64c59.83,21.92,57.43,106.43-3.08,125.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.98,36.77c.44,.08,.88,.16,1.32,.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.19,36.57c-3.58,0-6.48-4.63-6.48-6.8,0-.36-.77-.36-.77,0,0,2.08-2.67,6.8-6.89,6.8-.36,0-.36,.77,0,.77,3.68,0,6.89,5.04,6.89,6.8,0,.36,.77,.36,.77,0,0-2.09,2.99-6.8,6.48-6.8,.36,0,.36-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.1,165.62c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.2,53.61c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 58.22,
    y: 64.65,
    width: 105.41,
    height: 64.74,
    rx: 3.78,
    ry: 3.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.62,
    y: 60.46,
    width: 52.82,
    height: 22.17,
    rx: 3.7,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.98,
    y: 86.75,
    width: 33.19,
    height: 22.17,
    rx: 4.15,
    ry: 4.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 114.92,
    width: 58.19,
    height: 22.17,
    rx: 3.7,
    ry: 3.7,
    transform: "translate(-14.74 14.81) rotate(-7.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.65,
    y: 83.48,
    width: 26.41,
    height: 22.17,
    rx: 3.7,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.93,
    y: 86.75,
    width: 26.41,
    height: 22.17,
    rx: 3.7,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122.1,
    y: 56.92,
    width: 31.34,
    height: 22.17,
    rx: 3.7,
    ry: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.13,146.49c-3.14-9.24-3.06-25.54-3.06-25.54l-4.37-1.44s-9.6,13.18-17.62,18.75l-2.56,1.77c-2.17,6.61,3.11,11.17,11.28,13.94,8.22,2.61,15.18,2.07,17.35-4.54l-1.01-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.87,141.91c-1.61-4.74-1.57-13.1-1.57-13.1l-2.24-.74s-4.92,6.76-9.03,9.61l-1.31,.91c-1.11,3.39,1.6,5.73,5.78,7.15,4.21,1.34,7.78,1.06,8.9-2.33l-.52-1.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.41,90.79l-4.18-3c-.71-.51-.79-1.53-.16-2.14l1.47-1.43c.76-.74,.45-2.02-.56-2.34l-18.16-5.69c-1.15-.36-2.19,.81-1.69,1.91l7.33,16.24c.4,.88,1.56,1.1,2.25,.43l2.53-2.46c.63-.61,1.65-.5,2.14,.23l2.55,3.83c.46,.69,1.41,.83,2.05,.31l4.51-3.66c.72-.58,.68-1.69-.07-2.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 99.63,
    cy: 83.92,
    r: 1.62
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH678);
export default __webpack_public_path__ + "static/media/H67-8.b29aa9daa27967995f4850f2bbac567b.svg";
export { ForwardRef as ReactComponent };